import messages from "messages";

export const SIMPLE_TEXT_FIELDS = Object.freeze({
  problem: messages.presentingProblem,
});

export const RICH_TEXT_FIELDS = Object.freeze({
  goal: messages.goal,
  objective: messages.objective,
});

export const REMINDER_TYPES = Object.freeze({
  NONE: messages.none,
  AFTER: messages.after,
  ONDATE: messages.onDate,
});

export const REMINDER_DAYS = [7, 30, 60, 90, 365];
